import { HttpErrorResponse } from '@angular/common/http';
import { GenericCollection } from '../types/internal-types';

export class ErrorHelper {
  static extractMessage(error: unknown): string {
    if (typeof error === 'string' && error) {
      return error;
    }

    let errorMessage: unknown;

    if (error instanceof HttpErrorResponse) {
      errorMessage = error.error ?? error.error?.message ?? error.message;
    }

    if (!errorMessage && typeof error === 'object' && typeof (<GenericCollection>error)['message'] === 'string') {
      errorMessage = (<GenericCollection>error)['message'];
    }

	if(!errorMessage && error instanceof HttpErrorResponse && error.status && error.statusText) {
		errorMessage = `Error ${error.status} - ${error.statusText}`;
	}

    return errorMessage && typeof errorMessage === 'string' ? errorMessage : 'Unknown server error';
  }
}
